import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class LivepersonChatHandoverRecord
 * @augments BaseMessageRecord
 */
class LivepersonChatHandoverRecord extends BaseMessageRecord({
  type: "liveperson_handover",

  /**
   * @memberof LivepersonChatHandoverRecord#
   */
  skillId: null,
  unavailableAnswerId: null,
  acknowledgementBody: ""
}) {}

/**
 * Validation
 */

/**
 * @param {LivepersonChatHandoverRecord} message
 * @returns {Immutable.List.<String>}
 */
LivepersonChatHandoverRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.acknowledgementBody) {
    invalidFields.add("acknowledgementBody");
  }

  if (!message.unavailableAnswerId) {
    invalidFields.add("unavailableAnswerId");
  }

  if (!message.skillId) {
    invalidFields.add("skillId");
  }

  return Immutable.List(invalidFields);
};

export default LivepersonChatHandoverRecord;
